
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }

        gtag('js', new Date());

        gtag('config', 'G-JMFMXRZBTW');

        window.gtag = gtag;
    